import './BeWizrCourseLibraryItem'
import './BeWizrLearningTrackLibraryItem'
import './BeWizrMeetingLibraryItem'
import './BeWizrEmbedLibraryItem'
import './BeWizrLinkLibraryItem'
import './BeWizrMediaLibraryItem'
import React from 'react'
// @index(!registry): import ${relpath}
import { BeWizrLibraryItem } from '~/models'
import { getLibraryItemComponent } from './registry'

// /index

export default function renderLibraryItem(item: BeWizrLibraryItem) {
  const Component = getLibraryItemComponent(item)
  if (Component == null) {
    console.warn(`Cannot find widget component for widget "${item}"`)
    return null
  }

  return React.createElement(Component, {item})
}